<h2 mat-dialog-title class="default-dialog-header m-b-1">
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="p-t-0 p-b-1 default-dialog-content">
	<app-default-progress-bar *ngIf="isRequestInProgress"></app-default-progress-bar>
	<div class="p-8" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="0.5rem">
		<p>
			Please confirm your account by clicking the link in the Account Confirmation email you were
			sent before making offers on any loads.
		</p>
		<p>
			If you did not receive the email
			<span class="link resend-link" (click)="sendAccountConfirmationEmail()"
				>click here to resend it.</span
			>
		</p>
	</div>
</mat-dialog-content>
